import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAF8]">
        <Leaf className="h-8 w-8 text-[#275C3F] animate-pulse" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
